import { FormEvent, useEffect, useState } from "react";
import { EncryptionService } from "../../services/EncryptionService";
import { getContractsUrl } from "../../config";
import useAPI from "../../Hooks/useAPI";
import { useUser } from "../../Context/UserContext";
import { useNavigate } from "react-router-dom";
import sent from "../../Pages/Sent/Sent.module.css";
import Header from "../Header2/Header2";
import Footer from "../Footer/FooterSmall";

export interface UserData {
  source: string;
  company: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  title: string;
  id: string;
  entityId: string;
  streetaddress: string;
  city: string;
  state: string;
  zip: string;
  contractAdmin: boolean;
}
interface ReDirecteContractProps {
  dest: string;
}
const ReDirecteContract: React.FC<ReDirecteContractProps> = ({ dest }) => {
  const { user, setUser, hasPermission } = useUser();
  const [isReady, setIsReady] = useState(false);
  const { addUserTracking } = useAPI();

  const navigate = useNavigate();

  // if (!user) {
  //     return <div>User does not have permission</div>;
  // }

  useEffect(() => {
    // Redirect if not admin
    if (!user) {
      navigate("/");
      return;
    }
    if (dest === "ContractsDashboard" && !hasPermission("admin_contracts")) {
      navigate("/");
      return;
    }
  }, [user?.roles, navigate]);

  const [encryptionService] = useState(() => new EncryptionService());

  const encryptField = (value: string): string => {
    return encryptionService.encryptField(value);
  };

  useEffect(() => {
    const loadKey = async () => {
      try {
        await encryptionService.loadPublicKey();
        setIsReady(true);
      } catch (err) {
        console.error("Failed to load public key:", err);
      }
    };
    loadKey();
  }, [encryptionService]);

  useEffect(() => {
    if (!isReady || !user) return;

    const contractsUrl = getContractsUrl();

    if (!encryptionService.getPublicKey()) {
      alert("Public key not loaded");
      return;
    }

    const encryptedParams = (
      Object.keys(updatedUserData) as (keyof UserData)[]
    ).map(
      (key) =>
        `${fieldMap[key]}=${encodeURIComponent(
          encryptField(updatedUserData[key])
        )}`
    );

    const finalUrl = `${contractsUrl}/${dest}/?${encryptedParams.join("&")}`;
    console.log(finalUrl);
    window.location.href = finalUrl;
  }, [isReady, user]); // runs once key + user are ready

  if (!user) return null;

  const updatedUserData = {
    source: "Contracts<32Gem$",
    company: String(user.companyName), //check if has it?
    firstName: String(user.firstName),
    lastName: String(user.lastName),
    phone: String(user.phone), //check if has it?
    email: String(user.email),
    title: String(user.title),
    id: String(user.id),
    entityId: String(user.entityid),
    streetaddress: String(user.streetaddress),
    city: String(user.city),
    state: String(user.state),
    zip: String(user.zip),
    contractAdmin: "true",
  };

  const fieldMap: Record<keyof UserData, string> = {
    source: "r",
    company: "a",
    firstName: "b",
    lastName: "c",
    phone: "d",
    email: "e",
    title: "f",
    id: "g",
    entityId: "i",
    contractAdmin: "j",
    streetaddress: "k",
    city: "l",
    state: "m",
    zip: "n",
  };

  // const loadkey = async () => {
  //     const apiUrl = getContractsUrl();
  //     if (!encryptionService.getPublicKey()) {
  //         alert("Public key not loaded");
  //         return null;
  //     }

  //     const encryptedParams = (Object.keys(updatedUserData) as (keyof UserData)[]).map(
  //         key => `${fieldMap[key]}=${encodeURIComponent(encryptField(updatedUserData[key]))}`
  //     );
  //     const finalUrl = `${apiUrl}/?${encryptedParams.join("&")}`;
  //     console.log(finalUrl);
  //     window.location.href = finalUrl;
  // }
  // loadkey();

  return (
    <div className="generalPage">
      <div className="landingPage">
        <Header />
        <div className={sent.sentBody}>
          <h2>Your are being redirected</h2>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReDirecteContract;
